import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon';
import { PageSectionElementComponent } from './page-section-element.component';


@NgModule({
    declarations: [
        PageSectionElementComponent
    ],
    imports: [
        CommonModule,
        SvgIconModule
    ],
    exports: [
        PageSectionElementComponent
    ]
})
export class PageSectionElementModule { }
